import React, { useState } from "react";
import {
  checkButtonAccess,
  formatAmount,
  renderOrderStatus,
  renderStatus,
} from "../../../../Utils/CommonUtils";
import { Link } from "react-router-dom";
import dateFormat from "dateformat";
import { Button } from "react-bootstrap";
import { deleteOrder, renewOrder, releaseOrder } from "../OrderService";
import { DeleteListIcon } from "../../../../assets/images/svg/svg";
import ConfirmationModalDelete from "../../../../Components/Common/Modal/SaveChangesModal";
import OrderRestrictionModal from "./../Modal/OrderRestrictionModal";
import { showToast } from "../../../../common/Toaster/Toaster";

const OrderActionCell = ({ order }) => {
  const [showModal, setShowModal] = useState(false);
  const isRenewal = true;

  const handleDeleteConfirm = () => {
    deleteOrder(order.entityid);
    setShowModal(false);
  };

  const [restrictionError, setRestrictionError] = useState(null);

  const handleRenew = async () => {
    try {
      await renewOrder(order.entityid, isRenewal);
    } catch (error) {
      const errCode = error?.response?.data?.error_code;
      if (['ERR_022', 'ERR_023', 'ERR_024', 'ERR_025'].includes(errCode)) {
        setRestrictionError(error.response.data);
      } else {
        showToast(error?.response?.data?.error_message || "Error while renewing order", "error");
      }
    }
  };

  const handleRelease = () => {
    releaseOrder(order.entityid);
  };

  const canDelete =
    !(
      order.status === "COMPLETED" ||
      order.status === "PAYMENT_SUCCESS" ||
      order.status === "CANCELLED"
    ) && (checkButtonAccess ? checkButtonAccess("DELETE", "ORD_ORDS") : true);

  const canRenew =
    order.can_renew === 1 &&
    (checkButtonAccess ? checkButtonAccess("RENEW", "ORD_ORDS") : true);

  const canRelease =
    order.order_type === "FRESH" &&
    order.status === "PAYMENT_PENDING" &&
    Number(order.is_released) !== 1 &&
    (checkButtonAccess ? checkButtonAccess("RELEASE", "ORD_ORDS") : true);


  return (
    <>
      <div className="d-flex gap-4 align-items-center">
        {canRelease && (
          <Button variant="primary" onClick={handleRelease}>
            Release
          </Button>
        )}
        {canRenew && <Button onClick={handleRenew}>Renew</Button>}
        {canDelete && (
          <span onClick={() => setShowModal(true)}>
            <DeleteListIcon />
          </span>
        )}
      </div>

      <ConfirmationModalDelete
        isOpen={showModal}
        message="Are you sure you want to delete this order?"
        onConfirm={handleDeleteConfirm}
        onCancel={() => setShowModal(false)}
      />

      <OrderRestrictionModal
        show={!!restrictionError}
        handleClose={() => setRestrictionError(null)}
        errorData={restrictionError}
      />
    </>
  );
};

function useOrderColumn() {
  const orderColumn = [
    {
      header: "Order ID",
      accessorKey: "code",
      // cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/order/orders/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 100,
    },

    {
      header: "Date",
      accessorKey: "created_date",
      // cell: (props) => {
      //   {props?.getValue() ? props?.getValue() : "-"}
      // },
      size: 200,
    },
    {
      header: "Product",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Member",
      accessorKey: "billing_name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "Cover",
    //   accessorKey: "variant_json",
    //   cell: (props) => {
    //     const jsonString = props?.getValue();
    //     if (!jsonString) return "-";

    //     try {
    //       const variantObj = JSON.parse(jsonString);
    //       const coverAmount = variantObj?.cover
    //         ? Number(variantObj.cover)
    //         : null;
    //       return coverAmount ? formatAmount(coverAmount, null, null, "lakh") : "-";
    //     } catch (error) {
    //       console.log("Error in cover", error);
    //       return "-";
    //     }
    //   },
    //   size: 200,
    // },
    {
      header: "Amount",
      accessorKey: "gross_amount",
      cell: (props) => (props?.getValue() ? "₹ " + props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "AG",
      accessorKey: "ag_name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
    {
      header: "PROPOSAL FILLED",
      accessorKey: "proposal_filled",
      cell: (props) => {
        const rowData = props?.row?.original;
        // props?.getValue() ? renderStatus(props?.getValue()) : "-",
        return renderOrderStatus(rowData?.proposal_filled);
      },
      size: 160,
    },
    {
      header: "Insurer Name",
      accessorKey: "oem_name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: " AGM Number",
      accessorKey: "agm_number",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Cover Start Date",
      accessorKey: "cover_start_date",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Cover End Date",
      accessorKey: "cover_end_date",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Action",
      accessorKey: "action",
      cell: (props) => <OrderActionCell order={props.row.original} />,
    },
  ];

  return { orderColumn };
}

export default useOrderColumn;
